<div class="modal--container">
  <div class="modal-body">
    <div class="close-button--container">
      <app-mat-icon-button
        buttonStyle="default"
        iconName="close"
        ariaLabel="Close"
        (buttonClicked)="close()"
      ></app-mat-icon-button>
    </div>
    <h6>{{ titleText() }}</h6>
    <div class="grid--container">
      <div class="grid--item">
        <span class="title">Device:</span>
        <span>{{ errorLog()?.deviceName }}</span>
      </div>
      <div class="grid--item">
        <span class="title">Error:</span>
        <span>{{ errorLog()?.errorText }}</span>
      </div>
      <div class="grid--item">
        <span class="title">Details:</span>
        <span>{{ errorLog()?.detailedErrorText }}</span>
      </div>
      <div class="grid--item">
        <span class="title">Created at:</span>
        <span> {{ errorLog()?.createdAt | date: "dd/MM/yy, HH:mm a" }}</span>
      </div>
      <div class="grid--item">
        <span class="title">Viewed:</span>
        <span>
          @if (errorLog()?.viewed) {
            <mat-icon class="valid">check</mat-icon>
          }
          @if (!errorLog()?.viewed) {
            <mat-icon class="negative">close</mat-icon>
          }
        </span>
      </div>
      <div class="grid--item">
        <span class="title">Viewed by:</span>
        <span> {{ errorLog()?.viewedBy || "-" }} </span>
      </div>
      <div class="grid--item">
        <span class="title">Notes by:</span>
        <span> {{ errorLog()?.notesBy || "-" }} </span>
      </div>
      @if (!permissionToEdit()) {
        <div class="grid--item">
          <span class="title">Notes:</span>
          <span>{{ errorLog()?.notes }}</span>
        </div>
      }
    </div>
    @if (permissionToEdit()) {
      <form [formGroup]="notesForm" (ngSubmit)="buttonEventHandler()">
        <app-underlined-textarea-field
          [field]="notesField"
          [parentForm]="notesForm"
          [minLength]="minErrorLogNoteLength"
          [maxLength]="maxErrorLogNoteLength"
          [showCharacterCounter]="true">
        ></app-underlined-textarea-field>
        @if (errorLogUpdated()) {
          <div class="updated">
            <mat-icon class="valid">check_circle</mat-icon>
            <span class="body2">Your changes have been saved</span>
          </div>
        }
        <div class="double-button--container">
          <app-button
            class="modal-button"
            buttonStyle="secondary"
            label="Cancel"
            buttonId="cancel-btn"
            (buttonClicked)="close()"
            [isDisabled]="isProcessing()"
          ></app-button>
          <app-button
            class="modal-button"
            buttonType="submit"
            buttonStyle="standard"
            label="Update"
            buttonId="update-btn"
            [isDisabled]="notesForm.invalid || isProcessing() || isCharacterLimitExceeded"
            [isProcessing]="isProcessing()"
          ></app-button>
        </div>
      </form>
    }
    @if (!permissionToEdit()) {
      <div class="button--container">
        <app-button
          class="modal-button"
          buttonStyle="standard"
          label="Cancel"
          buttonId="cancel-btn"
          (buttonClicked)="close()"
          [isDisabled]="isProcessing()"
        ></app-button>
      </div>
    }
  </div>
</div>
<div class="modal--backdrop"></div>
